import React, { useEffect } from 'react';

import { ProgressIndicatorCircular } from '@andes/progress-indicator-circular';

import { useLoad } from '../../components/context/search';

const namespace = 'ui-search-overlay-spinner';

export const OverlaySpinner = () => {
  const load = useLoad();

  useEffect(() => {
    if (load) {
      document.body.classList.add('ui-search-no-scroll');
    } else {
      document.body.classList.remove('ui-search-no-scroll');
    }

    return () => {
      document.body.classList.remove('ui-search-no-scroll');
    };
  }, [load]);

  if (!load) {
    return null;
  }

  return (
    <div className={namespace}>
      <ProgressIndicatorCircular
        color="blue"
        id="progress-indicator-circular"
        modifier="block"
        size="medium"
        srLabel="Downloading file"
        type="indeterminate"
      />
    </div>
  );
};
